import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import type { UserRole } from "../types";
import { LoadingSpinner } from "./LoadingSpinner";

/** Client-side convenience gate. Server-side RBAC is the real enforcement. */
export function RoleGate({ roles, children }: { roles: UserRole[]; children: ReactNode }): JSX.Element {
  const { user, isLoading } = useAuth();

  if (isLoading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
}
